{
  "401": {
    "title": "No estás autorizado para acceder a esta página.",
    "text": "Si crees que esto no es correcto, contacta al administrador",
    "back_button": "Regresar al tablero"
  },
  "403": {
    "title": "No tienes permisos para acceder a esta página.",
    "text": "Si crees que esto es un error, contacta al administrador.",
    "back_button": "Regresar al tablero"
  },
  "404": {
    "title": "Esta página no se encontró.",
    "text": "La página solicitada no pudo ser encontrada.",
    "back_button": "Regresar al tablero"
  },
  "general": {
    "dateFormat": "dd/MM/yyyy",
    "fullDateFormat": "dd/MM/yyyy HH:mm:ss",
    "logout": "Cerrar sesión",
    "account": "Cuenta",
    "profile": "Perfil",
    "hello": "Hola",
    "home": "Inicio",
    "loading": "Cargando...",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "view": "Ver",
    "save": "Guardar",
    "records": "Registros",
    "add": "Agregar",
    "read": "Leer",
    "write": "Guardar",
    "edit": "Editar",
    "new": "Nuevo",
    "delete": "Eliminar",
    "actions": "Acciones",
    "active": "Activo",
    "inactive": "Inactivo",
    "search": "Buscar",
    "select": "Seleccionar",
    "none": "Ninguno",
    "yes": "Sí",
    "no": "No",
    "years": "Años",
    "months": "Meses",
    "favorites": "Favoritos",
    "reports": "Reportes",
    "recordsPerPage": "Registros por página",
    "changePassword": "Cambiar contraseña",
    "longDateFormat": "{years} año(s) y {months} mes(es)",
    "importData": "Importar datos",
    "upload": "Cargar",
    "downloadTemplate": "Descargar plantilla",
    "selectOption": "Seleccionar una opción",
    "id": "ID",
    "translations": "Traducciones",
    "or": "o",
    "review": "Revisar",
    "approve": "Aprobar",
    "reject": "Rechazar",
    "reviewComments": "Comentarios de Revisión",
    "reviewOnBehalfOf": "Revisar en nombre de",
    "reviewed": "Revisado",
    "reviewedBy": "Revisado Por ",
    "pending": "Pendiente",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "skipped": "Omitido",
    "warning": "Advertencia",
    "manager": "Gerente",
    "move": "Mover",
    "leave": "Salir",
    "export": "Exportar",
    "import": "Importar",
    "next": "Siguiente",
    "previous": "Anterior",
    "done": "Hecho",
    "run": "Ejecutar",
    "form": "Formulario",
    "status": "Estatus",
    "emailTemplate": "Plantilla de Correo",
    "send": "Enviar",
    "saving": "Guardando...",
    "saved": "Guardado",
    "loadData": "Cargar Datos",
    "download": "Descargar",
    "noData": "No hay datos disponibles en la tabla",
    "cropImage": "Recortar imagen",
    "selectImageToCrop": "Selecciona una imagen para recortar",
    "selectImage": "Seleccionar imagen",
    "list": "Lista",
    "group": "Grupo",
    "attach": "Adjuntar",
    "exportCsv": "Exportar CSV",
    "auditFields": "Campos de auditoría",
    "saveDisplayOrder": "Guardar orden de visualización",
    "permissionActions": {
      "read": "Leer",
      "write": "Escribir",
      "delete": "Eliminar",
      "execute": "Ejecutar"
    },
    "messages": {
      "personNotFound": "Persona no encontrada. Contactar al Administrador.",
      "notRegisteredSessionOnly": "No estás registrado en JTP, por lo que este cambio solo se aplicará a tu sesión actual. Por favor, contacta al administrador para ser agregado.",
      "formUnsavedChanges": "Tienes cambios sin guardar. ¿Estás seguro de que quieres cerrar?",
      "serverError": "Error del servidor. Inténtalo de nuevo más tarde o contacta al administrador del sistema.",
      "networkError": "No se pudo conectar al servidor. Verifica tu conexión a internet o contacta al administrador del sistema.",
      "forbidden": "No tienes permisos para acceder a este recurso. Contacta al administrador del sistema si crees que es un error.",
      "fileUploadError": "Error al cargar el archivo. Verifica el formato y tamaño del archivo e inténtalo de nuevo.",
      "fileUploadSuccessEmail": "Archivo cargado exitosamente. Se enviará un correo electrónico con el resultado de la importación próximamente.",
      "failedLoadPermissions": "Error al cargar los permisos de usuario. Actualiza la página o contacta al administrador del sistema.",
      "downloadingFile": "Descargando archivo...",
      "fileDownloadError": "Error al descargar el archivo. Inténtalo de nuevo o contacta al administrador del sistema.",
      "fileImportedSuccessfully": "Archivo importado exitosamente.",
      "invalidFileFormat": "Formato de archivo inválido. Por favor, revisa el archivo e inténtalo de nuevo.",
      "exportFailed": "No se pudieron exportar los datos. Inténtalo de nuevo o contacta al administrador del sistema."
    },
    "warnings": {
      "maxDisplayedRecords": "Mostrando {shown} registros de {filtered}. Para ver más registros, utilice la función de búsqueda."
    },
    "validation": {
      "required": "Este campo es obligatorio.",
      "email": "Por favor ingresa una dirección de correo válida.",
      "minValue": "El valor debe ser al menos {min}.",
      "maxValue": "El valor no puede ser mayor que {max}.",
      "minLength": "El valor debe tener al menos {min} caracteres.",
      "maxLength": "El valor no puede tener más de {max} caracteres.",
      "onlyIntegers": "El valor debe ser un número entero.",
      "invalidDate": "La fecha ingresada no es válida."
    },
    "baseAuditableEntity": {
      "createdBy": "Creado por",
      "createdDate": "Fecha de creación",
      "modifiedBy": "Modificado por",
      "modifiedDate": "Fecha de modificación"
    },
    "info": {
      "dragAndDropInfo": "Arrastra y suelta cualquier persona para organizar el arbol"
    }
  },
  "enums": {
    "potentialSuccessorType": {
      "1": "Interno",
      "2": "Externo"
    },
    "readinessFactor": {
      "0": "N/A",
      "1": "Listo Ahora",
      "2": "Listo con Desarrollo (1-2 Años)",
      "3": "Listo con Desarrollo (2-3 Años)",
      "4": "Sustitución de Emergencia"
    },
    "positionType": {
      "1": "Comprar",
      "2": "Hacer",
      "3": "Vender",
      "4": "Apoyar"
    },
    "communicationPriority": {
      "1": "Normal",
      "2": "Alta"
    }
  },
  "report": {
    "viewer": {
      "grid": {
        "pivotMode": "Modo Pivote",
        "groups": "Grupos de Filas",
        "rowGroupColumnsEmptyMessage": "Arrastre aquí para establecer grupos de filas",
        "values": "Valores",
        "valueColumnsEmptyMessage": "Arrastre aquí para agregar",
        "pivots": "Etiquetas de Columna",
        "pivotColumnsEmptyMessage": "Arrastre aquí para establecer etiquetas de columna",
        "columns": "Columnas",
        "filters": "Filtros",
        "loadingOoo": "Cargando...",
        "noRowsToShow": "No hay filas para mostrar",
        "enabled": "Habilitado",
        "group": "Grupo",
        "footerTotal": "Total",
        "filterOoo": "Filtrar...",
        "searchOoo": "Buscar...",
        "blanks": "(Vacíos)",
        "selectAll": "(Seleccionar Todo)",
        "selectAllSearchResults": "(Seleccionar Todos los Resultados de Búsqueda)",
        "noMatches": "Sin coincidencias",
        "equals": "Igual",
        "notEqual": "No es igual",
        "blank": "Vacío",
        "notBlank": "No vacío",
        "lessThan": "Menor que",
        "greaterThan": "Mayor que",
        "lessThanOrEqual": "Menor o igual que",
        "greaterThanOrEqual": "Mayor o igual que",
        "inRange": "Entre",
        "inRangeStart": "Desde",
        "inRangeEnd": "Hasta",
        "contains": "Contiene",
        "notContains": "No contiene",
        "startsWith": "Comienza con",
        "endsWith": "Termina con",
        "before": "Antes",
        "after": "Después",
        "andCondition": "Y",
        "orCondition": "O",
        "applyFilter": "Aplicar",
        "resetFilter": "Restablecer",
        "clearFilter": "Limpiar",
        "cancelFilter": "Cancelar",
        "textFilter": "Filtro de Texto",
        "numberFilter": "Filtro de Número",
        "dateFilter": "Filtro de Fecha",
        "setFilter": "Filtro de Conjunto",
        "pinColumn": "Fijar Columna",
        "pinLeft": "Fijar a la Izquierda",
        "pinRight": "Fijar a la Derecha",
        "noPin": "No Fijar",
        "valueAggregation": "Agregación de Valores",
        "noAggregation": "Ninguna",
        "autosizeThisColumn": "Autoajustar Esta Columna",
        "autosizeAllColumns": "Autoajustar Todas las Columnas",
        "groupBy": "Agrupar por",
        "ungroupBy": "Desagrupar por",
        "ungroupAll": "Desagrupar Todo",
        "addToValues": "Agregar {'${variable}'} a los valores",
        "removeFromValues": "Quitar {'${variable}'} de los valores",
        "addToLabels": "Agregar {'${variable}'} a las etiquetas",
        "removeFromLabels": "Quitar {'${variable}'} de las etiquetas",
        "resetColumns": "Restablecer Columnas",
        "expandAll": "Expandir Todos los Grupos de Filas",
        "collapseAll": "Contraer Todos los Grupos de Filas",
        "copy": "Copiar",
        "copyWithHeaders": "Copiar con Encabezados",
        "copyWithGroupHeaders": "Copiar con Encabezados de Grupo",
        "cut": "Cortar",
        "paste": "Pegar",
        "export": "Exportar",
        "csvExport": "Exportar CSV",
        "excelExport": "Exportar Excel",
        "sum": "Suma",
        "first": "Primero",
        "last": "Último",
        "min": "Mín",
        "max": "Máx",
        "count": "Conteo",
        "avg": "Promedio",
        "average": "Promedio",
        "filteredRows": "Filtradas",
        "selectedRows": "Seleccionadas",
        "totalRows": "Total de Filas",
        "totalAndFilteredRows": "Filas"
      },
      "noFilterMessage": "No hay filtros para este reporte",
      "noAccessReport": "No tienes acceso para ver este reporte. Contacta al administrador del sistema si crees que es un error.",
      "pdfSizeErrorMessage": "El tamaño del PDF es demasiado grande y no se puede mostrar.",
      "pdfMaxSizeDownloaded": "El reporte es demasiado grande para mostrar. Revisa tu carpeta de descargas.",
      "failedLoadReports": "Error al cargar reportes. Otras funcionalidades trabajarán como se espera. Actualiza la página o contacta al administrador del sistema si el problema persiste.",
      "run": "Ejecutar",
      "download": "Descargar",
      "viewFilter": {
        "button": "Ver Filtros...",
        "title": "Parámetros",
        "name": "Nombre",
        "value": "Valor"
      },
      "fullScreen": "Pantalla Completa...",
      "smallScreen": "Pantalla Pequeña...",
      "tabButton": {
        "fullScreen": "Ocultar sección de parámetros",
        "smallScreen": "Mostrar sección de parámetros",
        "about": "Acerca de",
        "downloadExcel": "Descargar archivo de Hoja de Cálculo",
        "clear": "Cerrar Todas las Pestañas"
      },
      "modalAbout": {
        "title": "Acerca de",
        "description": "Descripción",
        "version": "Versión",
        "reference": "Referencia",
        "lastChange": "Último Cambio",
        "dataSource": "Fuente de Datos"
      }
    },
    "maintenance": {
      "menuName": "Reportes",
      "pageTitle": "Reportes",
      "id": "ID",
      "title": "Título",
      "reference": "Referencia",
      "directoryTree": "Árbol de Directorios",
      "directoryTreeHelp": "Usa barra invertida para separar carpetas, ej. Reportes\\Finanzas\\Mensual",
      "reportType": "Tipo de Reporte",
      "typeGrid": "Cuadrícula",
      "typeForm": "Formulario",
      "securityResource": "Recurso de Seguridad",
      "description": "Descripción",
      "versionNumber": "Versión",
      "isActive": "Activo",
      "isSchedulable": "Programable",
      "isArchivable": "Archivable",
      "isAuditable": "Auditable",
      "passMultiValue": "Pasar Multivalor como Cadena",
      "expireInDays": "Vencer en Días",
      "add": "Agregar Reporte",
      "edit": "Editar Reporte",
      "delete": {
        "title": "Eliminar Reporte",
        "text": "¿Estás seguro de que deseas eliminar \"{name}\"?"
      },
      "messages": {
        "created": "Reporte creado exitosamente.",
        "updated": "Reporte guardado exitosamente.",
        "deleted": "Reporte eliminado exitosamente.",
        "imported": "Reporte importado exitosamente."
      },
      "sections": {
        "main": "Propiedades Principales",
        "parameters": "Parámetros",
        "sqls": "Sentencias SQL",
        "grids": "Cuadrículas de Resultado",
        "models": "Modelos de Reporte"
      },
      "sql": {
        "add": "Agregar Sentencia SQL",
        "edit": "Editar Sentencia SQL",
        "description": "Descripción",
        "connection": "Conexión",
        "multipleResultset": "Múltiples Conjuntos de Resultados",
        "sql": "SQL",
        "generateGrids": "Generar Cuadrículas desde SQL",
        "generateGridsSuccess": "Cuadrícula generada exitosamente. Revísala en la pestaña Cuadrículas de Resultado.",
        "delete": {
          "title": "Eliminar Sentencia SQL",
          "text": "¿Estás seguro de que deseas eliminar \"{name}\"?"
        }
      },
      "grid": {
        "add": "Agregar Cuadrícula",
        "edit": "Editar Cuadrícula",
        "label": "Etiqueta",
        "resultsetNumber": "N° de Conjunto de Resultados",
        "parentGrid": "Cuadrícula Padre",
        "defaultGroupedColumns": "Columnas Agrupadas por Defecto",
        "relationString": "Cadena de Relación",
        "delete": {
          "title": "Eliminar Cuadrícula",
          "text": "¿Estás seguro de que deseas eliminar \"{name}\"?"
        }
      },
      "column": {
        "add": "Agregar Columna",
        "edit": "Editar Columna",
        "columnName": "Nombre de Columna",
        "label": "Etiqueta",
        "header": "Encabezado",
        "dataType": "Tipo de Datos",
        "sumarizeType": "Resumir",
        "showOrder": "Orden",
        "mask": "Máscara",
        "helpText": "Texto de Ayuda",
        "template": "Plantilla",
        "delete": {
          "title": "Eliminar Columna",
          "text": "¿Estás seguro de que deseas eliminar \"{name}\"?"
        }
      },
      "param": {
        "add": "Agregar Parámetro",
        "edit": "Editar Parámetro",
        "displayOrder": "Orden",
        "name": "Nombre",
        "nameValidation": "Solo se permiten letras, números y guiones bajos.",
        "label": "Etiqueta",
        "dataType": "Tipo de Datos",
        "defaultValue": "Valor por Defecto",
        "helpText": "Texto de Ayuda",
        "required": "Requerido",
        "multiple": "Múltiples Valores",
        "width": "Ancho (cols)",
        "enumValues": "Valores (separados por punto y coma)",
        "enumValuesHelp": "ej. 1;2;3",
        "enumLabels": "Etiquetas (separadas por punto y coma)",
        "enumLabelsHelp": "ej. Opción A;Opción B;Opción C",
        "sql": "Consulta SQL",
        "generate": "Generar parámetros desde SQL",
        "delete": {
          "title": "Eliminar Parámetro",
          "text": "¿Estás seguro de que deseas eliminar \"{name}\"?"
        }
      },
      "model": {
        "add": "Agregar Modelo",
        "edit": "Editar Modelo",
        "description": "Descripción",
        "order": "Orden",
        "connection": "Conexión",
        "file": "Archivo de Modelo (.trdx / .trdp)",
        "fileLoaded": "Archivo cargado exitosamente.",
        "delete": {
          "title": "Eliminar Modelo",
          "text": "¿Estás seguro de que deseas eliminar \"{name}\"?"
        }
      },
      "paramDataType": {
        "text": "Texto",
        "number": "Número",
        "date": "Fecha",
        "time": "Hora",
        "combo": "Combo",
        "boolean": "Booleano",
        "sql": "SQL"
      },
      "colDataType": {
        "text": "Texto",
        "number": "Número",
        "date": "Fecha",
        "time": "Hora",
        "combo": "Combo",
        "boolean": "Booleano"
      },
      "sumarizeType": {
        "nosumarize": "Ninguno",
        "sum": "Suma",
        "min": "Mín",
        "max": "Máx",
        "average": "Promedio",
        "count": "Conteo"
      },
      "import": {
        "connection": "Anulación de Conexión",
        "connectionHelp": "Opcional: anular todas las referencias de conexión en el archivo importado."
      }
    }
  },
  "file": {
    "description": "Descripción",
    "files": "Archivos",
    "editDescription": "Editar Descripción",
    "delete": "Eliminar Archivo",
    "download": "Descargar Archivo",
    "pendingUpload": "Carga pendiente. El archivo solo se guardará después de hacer clic en 'Guardar'.",
    "noFiles": "No se han agregado archivos."
  },
  "dashboard": {
    "menuTitle": "Tablero",
    "title": "Tablero",
    "addWidget": "Agregar Widget",
    "editLayout": "Editar Diseño",
    "saveLayout": "Guardar Diseño",
    "importLayout": "Importar Diseño",
    "exportLayout": "Exportar Diseño",
    "category": "Categoría",
    "widget": "Widget",
    "widgetTitle": "Título",
    "widgetParameters": "Parámetros",
    "widgetInformation": "Información del Widget",
    "noParameters": "Este widget no tiene parámetros.",
    "delete": "Eliminar Widget",
    "viewLink": "ver",
    "noItemsToDisplay": "No hay elementos para mostrar",
    "messages": {
      "saveSuccess": "Diseño guardado exitosamente.",
      "importSuccess": "Diseño importado exitosamente.",
      "exportSuccess": "Diseño exportado exitosamente.",
      "importFailed": "Error al importar diseño.",
      "widgetNotFound": "Widget no encontrado",
      "failedToLoad": "Error al cargar",
      "noDataAvailable": "No hay datos disponibles",
      "noParametersConfigured": "No hay parámetros configurados para este widget."
    },
    "tutorial": {
      "mainMessage": "¡Bienvenido a tu panel de control! Usa los botones de arriba para personalizarlo.",
      "callToAction": "¡Muéstrame cómo!",
      "instructions": {
        "add": {
          "title": "Botón Agregar Widget",
          "description": "Aquí podrás encontrar widgets por categoría. Algunos de ellos pueden tener parámetros para permitirte un dashboard completamente personalizable. No olvides hacer clic en GUARDAR después de agregar todos tus widgets."
        },
        "edit": {
          "title": "Editar Diseño de Widget",
          "description": "Aquí podrás cambiar tu dashboard: Agregar o quitar widgets, moverlos y cambiar su tamaño. No olvides guardar después de editar."
        },
        "import": {
          "title": "Importar Diseño",
          "description": "Con un archivo de respaldo, aquí puedes importarlo. Nota: Tu dashboard será sobrescrito."
        },
        "export": {
          "title": "Exportar Diseño",
          "description": "Una vez que tengas tu dashboard completo, puedes exportarlo para tener una copia de seguridad O enviárselo a otro usuario para que copie tu dashboard."
        }
      }
    }
  },
  "communication": {
    "title": "Comunicaciones",
    "menuTitle": "Comunicaciones",
    "menuName": "Comunicaciones",
    "inbox": "Bandeja de Entrada",
    "markAsRead": "Marcar como Leído",
    "subject": "Asunto",
    "date": "Fecha",
    "priority": "Prioridad",
    "backToInbox": "Volver a la Bandeja",
    "noMessages": "No hay mensajes en su bandeja de entrada.",
    "status": "Estado",
    "read": "Leído",
    "unread": "No Leído",
    "edit": "Ver",
    "messages": {
      "markedAsRead": "Comunicación reconocida"
    }
  },
  "settings": {
    "title": "Configuración",
    "theme": {
      "name": "Tema",
      "dark": "Oscuro",
      "light": "Claro"
    }
  },
  "userInfo": {
    "title": "Información de Usuario",
    "permissions": "Permisos",
    "userName": "Nombre de usuario",
    "fullName": "Nombre Completo",
    "email": "Correo electrónico",
    "employeeId": "ID de Empleado",
    "action": "Acción",
    "permissionCode": "Código de Permiso"
  },
  "profile": {
    "title": "Mi Perfil",
    "menuName": "Perfil",
    "score": "Puntuación de perfil",
    "managerWarning": "La información proporcionada en la página \"Mi perfil\" es accesible para los gerentes y RR. HH. de la organización con fines de mapeo de talento.",
    "photo": "Cambiar imagen",
    "name": "Nombre",
    "email": "Correo electrónico",
    "manager": "Gerente",
    "position": "Posición",
    "plant": "Planta",
    "businessArea": "Área de negocios",
    "degreeType": "Título",
    "degreeName": "Nombre del Título o Certificado",
    "language": "Idioma",
    "languagesInfo": "Selecciona todos los idiomas que hablas",
    "geoMobility": {
      "label": "Movilidad geográfica",
      "none": "Ninguno",
      "local": "Local",
      "national": "Nacional",
      "international": "Internacional"
    },
    "businessMobility": "Movilidad de unidad de negocios",
    "skills": "Mis habilidades",
    "skillsInfo": "Selecciona tus áreas de especialización",
    "careerInterests": "Intereses profesionales",
    "careerAspirations": "Aspiraciones profesionales",
    "jobHistory": "Historial laboral relevante",
    "save": "Guardar",
    "invalidPhotoFormat": "Imagen con una extensión inválida",
    "photoCrop": {
      "title": "Foto de perfil",
      "selectImage": "Cargar",
      "confirm": "Aplicar",
      "cancel": "Cancelar",
      "deletePhoto": "Eliminar",
      "hint": "Arrastra para reposicionar. Pellizca o desplaza para hacer zoom.",
      "emptyState": "No hay imagen seleccionada. Haz clic en \"Cargar\" para comenzar."
    },
    "messages": {
      "saved": "Perfil guardado con éxito",
      "notRegistered": "No estás registrado en JTP. Por favor, contacta a RR. HH. para ser agregado. Hasta entonces, tu acceso estará restringido."
    }
  },
  "impersonate": {
    "title": "Suplantar Usuario",
    "userName": "Usuario",
    "start": "Iniciar Suplantación",
    "messages": {
      "impersonationStarted": "Sesión de suplantación iniciada. Para regresar a tu cuenta, cierra sesión e inicia sesión nuevamente.",
      "userNotFound": "Usuario no encontrado. Verifica el nombre de usuario e inténtalo de nuevo."
    }
  },
  "about": {
    "menuName": "Acerca de",
    "title": "Acerca de"
  },
  "releaseNotes": {
    "menuName": "Notas de Lanzamiento",
    "title": "Notas de Lanzamiento",
    "name": "Nombre",
    "version": "Versión",
    "description": "Descripción",
    "appType": "Tipo de Aplicación",
    "releaseDate": "Fecha de Lanzamiento",
    "messages": {
      "notFound": "Nota de lanzamiento no encontrada.",
      "saveError": "Error al guardar la nota de lanzamiento. Inténtalo de nuevo más tarde."
    }
  },
  "help": {
    "menuTitle": "Ayuda",
    "externalLinkMessage": "Está a punto de abrir un enlace externo:",
    "externalLinkConfirm": "Abrir enlace",
    "lastUpdated": "Última actualización: {date}",
    "wasThisHelpful": "¿Te resultó útil?",
    "helpful": "Útil",
    "notHelpful": "No útil",
    "pageModal": {
      "title": "Ayuda de esta página",
      "intro": "Los artículos de ayuda muestran orientación para la página en la que estás. Selecciona uno para abrirlo o cierra esta ventana."
    }
  },
  "admin": {
    "menuTitle": "Administración",
    "appCustomizations": {
      "menuName": "Personalizaciones de la App",
      "pageTitle": "Personalizaciones de la App",
      "imageLogos": "Logotipos de Imagen",
      "headerLogo": "Logotipo del Encabezado",
      "menuLogo": "Logotipo del Menú",
      "bannerImage": "Imagen de Banner",
      "upload": "Subir",
      "remove": "Eliminar",
      "noCustom": "Imagen predeterminada",
      "preview": "Vista previa",
      "messages": {
        "saved": "Personalizaciones guardadas correctamente.",
        "invalidKey": "Clave de logotipo no válida.",
        "invalidLanguage": "Código de idioma no válido.",
        "fileRequired": "El archivo es obligatorio.",
        "fileTooLarge": "El archivo supera el tamaño máximo permitido de 2 MB.",
        "fileTypeNotAllowed": "Tipo de archivo no permitido. Use PNG, JPEG o WebP.",
        "notFound": "Personalización no encontrada."
      }
    },
    "help": {
      "menuName": "Ayuda",
      "pageTitle": "Ayuda",
      "title": "Título",
      "description": "Descripción",
      "isActive": "Activo",
      "displayOrder": "Orden de Visualización",
      "securityResources": "Recursos de Seguridad",
      "securityResourcesInfo": "Lista de permisos separados por comas. Déjelo vacío para que sea visible para todos; de lo contrario, el usuario debe tener al menos uno de los permisos indicados.",
      "isMenuDisplayed": "Mostrar en el Menú",
      "isMenuDisplayedInfo": "Cuando está desactivado, esta ayuda se oculta del menú de Ayuda, pero aún puede abrirse desde el icono de ayuda en las páginas asociadas.",
      "isTrackingEnabled": "Habilitar Seguimiento",
      "isTrackingEnabledInfo": "Cuando está activado, las vistas se registran por empleado y se muestra una valoración \"¿te resultó útil?\" en la página de ayuda.",
      "viewCount": "Vistas",
      "viewCountValue": "Visto {views} veces por {viewers} personas",
      "viewCountInfo": "Número total de vistas y la cantidad de empleados distintos que abrieron esta ayuda.",
      "helpfulCount": "Útil",
      "notHelpfulCount": "No útil",
      "associatedMenus": "Páginas Asociadas",
      "associatedMenusInfo": "Vincula esta ayuda a una o más páginas para que pueda abrirse directamente desde el icono de ayuda en esas páginas.",
      "addMenu": "Agregar página",
      "add": "Agregar Ayuda",
      "edit": "Editar Ayuda",
      "delete": {
        "title": "Eliminar Ayuda",
        "text": "¿Está seguro de que desea eliminar esta entrada de ayuda?"
      },
      "messages": {
        "created": "Ayuda creada con éxito.",
        "updated": "Ayuda actualizada con éxito.",
        "deleted": "Ayuda eliminada con éxito.",
        "notFound": "Ayuda no encontrada."
      }
    },
    "menuHierarchy": {
      "menuName": "Jerarquía de Menú",
      "pageTitle": "Jerarquía de Menú",
      "displayName": "Nombre para Mostrar",
      "route": "Ruta",
      "routeParam": "Parámetro de Menú",
      "securityResources": "Recursos de Seguridad",
      "children": "Sub-Menús",
      "isActive": "Está Activo",
      "icon": "Ícono",
      "iconHelpText": "Biblioteca de iconos",
      "displayOrder": "Orden de Visualización",
      "edit": "Editar Elemento de Menú",
      "messages": {
        "success": "Elemento de menú guardado exitosamente."
      }
    },
    "notificationTemplate": {
      "menuName": "Plantilla de Notificación",
      "pageTitle": "Plantilla de Notificación",
      "name": "Nombre",
      "parent": "Plantilla Padre",
      "parentInfo": "Solo las plantillas que comienzan con masterTemplate pueden ser usadas como plantilla padre.",
      "pushNotificationEnabled": "Notificación Push Habilitada",
      "pushRoute": "Ruta de Notificación Push",
      "sqlQuery": "Consulta SQL",
      "sqlQueryDateFormatInfo": "Las columnas de fecha deben estar formateadas en formato MM/dd/yyyy.",
      "generalSection": "Información General",
      "emailSection": "Notificación por Correo",
      "emailSubject": "Asunto del Correo",
      "emailBody": "Cuerpo del Correo (HTML)",
      "pushSection": "Notificación Push",
      "pushSubject": "Asunto Push",
      "pushBody": "Cuerpo Push",
      "overrideNotificationTemplate": "Sobrescribir Plantilla de Notificación",
      "add": "Agregar Plantilla",
      "edit": "Editar Plantilla",
      "delete": {
        "title": "Eliminar Plantilla",
        "text": "¿Estás seguro de que quieres eliminar la plantilla \"{name}\"?"
      },
      "attachment": {
        "title": "Adjuntar Archivo",
        "attachment": "Archivo Adjunto",
        "attach": "Adjuntar",
        "noAttachedFile": "No hay archivo adjunto...",
        "messages": {
          "uploadedSuccessfully": "Archivo adjunto cargado exitosamente."
        },
        "delete": {
          "title": "Eliminar Archivo Adjunto",
          "text": "¿Estás seguro de que quieres eliminar el archivo adjunto \"{name}\"?"
        }
      },
      "messages": {
        "created": "Plantilla de notificación creada exitosamente.",
        "updated": "Plantilla de notificación actualizada exitosamente.",
        "deleted": "Plantilla de notificación eliminada exitosamente.",
        "alreadyExists": "Ya existe una plantilla de notificación con este nombre.",
        "fileRequired": "El archivo es obligatorio.",
        "importError": "Ocurrió un error al importar la plantilla de notificación.",
        "notFound": "Plantilla de notificacion no encontrada."
      }
    },
    "department": {
      "menuName": "Departamento",
      "pageTitle": "Departamento",
      "name": "Nombre",
      "isActive": "Está Activo",
      "add": "Agregar Departamento",
      "edit": "Editar Departamento",
      "delete": {
        "title": "Eliminar Departamento",
        "text": "¿Estás seguro de que quieres eliminar este departamento?"
      },
      "messages": {
        "created": "Departamento creado exitosamente.",
        "updated": "Departamento actualizado exitosamente.",
        "deleted": "Departamento eliminado exitosamente."
      }
    },
    "businessArea": {
      "menuName": "Área de Negocio",
      "pageTitle": "Área de Negocio",
      "id": "Id",
      "externalId": "Id Externo",
      "description": "Descripción",
      "calendarId": "Calendario",
      "isActive": "Está Activo",
      "edit": "Editar Área de Negocio",
      "messages": {
        "created": "Área de Negocio creada exitosamente.",
        "updated": "Área de Negocio actualizada exitosamente.",
        "deleted": "Área de Negocio eliminada exitosamente."
      }
    },
    "businessUnit": {
      "menuName": "Unidad de Negocio",
      "pageTitle": "Unidad de Negocio",
      "id": "Id",
      "externalId": "Id Externo",
      "description": "Descripción",
      "isActive": "Está Activa",
      "edit": "Editar Unidad de Negocio",
      "messages": {
        "created": "La Unidad de Negocio se creó correctamente.",
        "updated": "La Unidad de Negocio se actualizó correctamente.",
        "deleted": "La Unidad de Negocio se eliminó correctamente.",
        "inUse": "El registro de Unidad de Negocio está en uso. Primero elimine sus dependencias.",
        "notFound": "No se encontró el registro de la Unidad de Negocio"
      },
      "add": "Agregar Unidad de Negocio",
      "delete": {
        "title": "Eliminar Unidad de Negocio",
        "text": "¿Está seguro de que desea eliminar esta Unidad de Negocio?"
      }
    },
    "division": {
      "menuName": "División",
      "pageTitle": "División",
      "id": "Id",
      "externalId": "Id Externo",
      "description": "Descripción",
      "isActive": "Está Activa",
      "businessUnitId": "Unidad de Negocio",
      "edit": "Editar División",
      "messages": {
        "created": "La División se creó correctamente.",
        "updated": "La División se actualizó correctamente.",
        "deleted": "La División se eliminó correctamente."
      },
      "add": "Agregar División",
      "delete": {
        "title": "Eliminar División",
        "text": "¿Está seguro de que desea eliminar esta División?"
      }
    },
    "organization": {
      "menuName": "Organización",
      "pageTitle": "Organización",
      "id": "ID",
      "externalId": "ID Externo",
      "name": "Nombre",
      "plantAreaId": "Área de Planta",
      "organizationParentId": "Organización principal",
      "edit": "Editar Organización",
      "messages": {
        "created": "La organización se creó correctamente.",
        "updated": "La organización se actualizó correctamente.",
        "deleted": "La organización se eliminó correctamente."
      },
      "add": "Agregar Organización",
      "delete": {
        "title": "Eliminar Organización",
        "text": "¿Está seguro de que desea eliminar esta organización?"
      }
    },
    "plant": {
      "menuName": "Planta",
      "pageTitle": "Planta",
      "id": "Id",
      "name": "Nombre",
      "alias": "Alias",
      "isActive": "Está Activo",
      "divisionId": "División",
      "countryId": "País",
      "employeeCanUpdateGoals": "El empleado puede actualizar objetivos",
      "employeeCanUpdateTracks": "El empleado puede actualizar resultados",
      "employeeCanIncludeKPI": "El empleado puede crear KPI",
      "managerCanUpdateGoals": "El gerente puede actualizar objetivos",
      "managerCanUpdateTracks": "El gerente puede actualizar resultados",
      "managerCanIncludeKPI": "El gerente puede crear KPI",
      "edit": "Editar Planta",
      "messages": {
        "created": "Planta creada exitosamente.",
        "updated": "Planta actualizada exitosamente.",
        "deleted": "Planta eliminada exitosamente.",
        "inUse": "El registro de la Planta está en uso. Elimine primero los registros relacionados.",
        "notFound": "Registro de Planta no encontrado"
      },
      "add": "Agregar Planta",
      "delete": {
        "title": "Eliminar Planta",
        "text": "¿Está seguro de que desea eliminar esta Planta?"
      }
    },
    "personnelArea": {
      "menuName": "Área de Personal",
      "pageTitle": "Área de Personal",
      "id": "Id",
      "description": "Descripción",
      "externalId": "Id Externo",
      "plantId": "Planta",
      "isActive": "Activo",
      "sourceModifiedDate": "Fecha de Modificación de Origen",
      "edit": "Editar Área de Personal",
      "messages": {
        "created": "Área de Personal creada correctamente.",
        "updated": "Área de Personal actualizada correctamente.",
        "deleted": "Área de Personal eliminada correctamente.",
        "inUse": "El registro de Área de Personal está en uso. Primero elimine sus usos.",
        "notFound": "Registro de Área de Personal no encontrado",
        "alreadyExists": "Ya existe un área de personal con esta descripción.",
        "fileRequired": "El archivo es obligatorio.",
        "importError": "Ocurrió un error al importar el área de personal.",
        "invalidPlant": "Id de Planta inválido",
        "duplicateExternalId": "Id Externo duplicado",
        "importSuccess": "Área de Personal importada correctamente. Recibirás el archivo por correo electrónico",
        "exportSuccess": "Área de Personal exportada correctamente. Recibirás el archivo por correo electrónico",
        "exportFailed": "Error al exportar el área de personal.",
        "importFailed": "Error al importar el área de personal.",
        "personNotFound": "Persona no encontrada para realizar la importación. Contacte al Administrador.",
        "emailNotFound": "Correo electrónico no encontrado para realizar la importación. Contacte al Administrador.",
        "importFalied": "La importación del área de personal falló."
      },
      "add": "Agregar Área de Personal",
      "delete": {
        "title": "Eliminar Área de Personal",
        "text": "¿Está seguro de que desea eliminar esta Área de Personal?"
      }
    },
    "position": {
      "menuName": "Posición",
      "pageTitle": "Posición",
      "id": "Id",
      "description": "Descripción",
      "externalId": "Id Externo",
      "active": "Activo",
      "jobCode": "Puesto",
      "jobId": "Puesto",
      "organizationId": "Organización",
      "employeeSubGroupId": "Subgrupo de Empleados",
      "costCenterId": "Centro de Costos",
      "salaryLevelId": "Nivel Salarial",
      "businessAreaId": "Área de Negocio",
      "bonusFrequencyId": "Frecuencia de Bono",
      "personnelAreaCode": "Área de Personal",
      "payGradeType": "Tipo de Grado Salarial",
      "payGradeArea": "Área de Grado Salarial",
      "employeeGroupId": "Grupo de Empleados",
      "salaryGroupId": "Grupo Salarial",
      "minimum": "Mínimo",
      "midpoint": "Punto Medio",
      "edit": "Editar Área de Posición",
      "messages": {
        "created": "Posición creada exitosamente.",
        "updated": "Posición actualizada exitosamente.",
        "inUse": "El registro de posición está en uso. Primero elimine sus usos.",
        "notFound": "Registro de posición no encontrado"
      },
      "add": "Agregar Posición"
    },
    "positionProfile": {
      "pageTitle": "Posición Crítica",
      "globalCritical": "Crítico Global",
      "countryCritical": "Crítico por País",
      "businessUnitCritical": "Crítico por Unidad de Negocio",
      "positionType": "Tipo de Posición",
      "sucessorType": "Tipo de Sucesor",
      "potentialSuccessorType": "Tipo de Sucesor",
      "potentialSuccessorId": "Sucesor Potencial",
      "readinessFactor": "Factor de Preparación",
      "potentialSuccessorName": "Nombre",
      "potentialSuccessorCompany": "Empresa",
      "potentialSuccessorLinkedIn": "URL de LinkedIn",
      "potentialSuccessorNotes": "Notas",
      "messages": {
        "created": "La Posición Crítica se creó correctamente.",
        "updated": "La Posición Crítica se actualizó correctamente."
      }
    },
    "configuration": {
      "menuName": "Configuración",
      "pageTitle": "Configuración",
      "key": "Clave",
      "value": "Valor",
      "editorType": "Tipo",
      "add": "Agregar Configuración",
      "edit": "Editar Configuración",
      "delete": {
        "title": "Eliminar Configuración",
        "text": "¿Estás seguro de que quieres eliminar esta configuración?"
      },
      "messages": {
        "created": "Configuración creada exitosamente.",
        "updated": "Configuración actualizada exitosamente.",
        "deleted": "Configuración eliminada exitosamente."
      },
      "types": {
        "text": "Texto",
        "string": "Cadena",
        "number": "Número",
        "int": "Entero",
        "boolean": "Booleano"
      }
    },
    "widget": {
      "menuName": "Widget",
      "pageTitle": "Widget",
      "name": "Nombre",
      "description": "Descripción",
      "securityResources": "Recursos de Seguridad",
      "link": "Enlace",
      "query": "Consulta SQL",
      "queryRequired": "La consulta SQL es obligatoria.",
      "sqlQueryDateFormatInfo": "Las columnas de fecha deben estar formateadas en formato MM/dd/yyyy.",
      "minHeight": "Altura Mínima",
      "minWidth": "Ancho Mínimo",
      "autoApplied": "Aplicar a todos los paneles",
      "autoAppliedHelp": "Esto forzará este widget en todos los paneles, y los usuarios seguirán viéndolo aunque intenten eliminarlo.",
      "type": "Tipo",
      "category": "Categoría",
      "add": "Agregar Widget",
      "edit": "Editar Widget",
      "delete": {
        "title": "Eliminar Widget",
        "text": "¿Estás seguro de que quieres eliminar este widget?"
      },
      "examples": {
        "viewSQLExamples": "Ver ejemplos SQL",
        "general": "General",
        "generalDescription": "Por defecto, el sistema proporciona los siguientes parámetros, que pueden ser referenciados directamente en cualquier consulta SQL de widget.",
        "loggedUserNameDescription": "Nombre de usuario de inicio de sesión del usuario actualmente conectado (por ejemplo: {email}).",
        "loggedUserEmployeeIdDescription": "Identificador de empleado del usuario actualmente conectado.",
        "loggedUserLanguageDescription": "Código de idioma del usuario actualmente conectado (por ejemplo: en-US, pt-BR).",
        "loggedUserUniqueIdDescription": "Id único del usuario (Guid)",
        "loggedUserEncryptedUniqueIdDescription": "Id único cifrado del usuario",
        "listDescription": "Cada fila representa un elemento de la lista.",
        "numberDescription": "Retorna un solo valor numérico.",
        "donutDescription": "Las etiquetas y valores deben alinearse por posición.",
        "lineDescription": "Cada fila representa una serie de líneas."
      },
      "messages": {
        "created": "Widget creado exitosamente.",
        "updated": "Widget actualizado exitosamente.",
        "deleted": "Widget eliminado exitosamente.",
        "fileRequired": "El archivo es obligatorio.",
        "importError": "Ocurrió un error al importar el widget.",
        "queryVariablesMissing": "Las siguientes variables faltan en la consulta del widget: \"{variables}\". Por favor, agrégalas a la consulta para asegurar un funcionamiento correcto."
      }
    },
    "reportColumnTemplate": {
      "menuName": "Plantillas de Columnas de Reporte",
      "pageTitle": "Plantillas de Columnas de Reporte",
      "id": "ID",
      "description": "Descripción",
      "template": "Plantilla",
      "templateHelp": "Usa {value} como marcador de posición para el valor de la celda. HTML es compatible.",
      "add": "Agregar Plantilla",
      "edit": "Editar Plantilla",
      "delete": {
        "title": "Eliminar Plantilla",
        "text": "¿Estás seguro de que quieres eliminar \"{name}\"?"
      },
      "messages": {
        "created": "Plantilla creada exitosamente.",
        "updated": "Plantilla actualizada exitosamente.",
        "deleted": "Plantilla eliminada exitosamente."
      }
    },
    "widgetCategory": {
      "menuName": "Categoría de Widget",
      "pageTitle": "Categoría de Widget",
      "name": "Nombre",
      "description": "Descripción",
      "type": "Tipo",
      "add": "Agregar Categoría de Widget",
      "edit": "Editar Categoría de Widget",
      "delete": {
        "title": "Eliminar Categoría de Widget",
        "text": "¿Estás seguro de que quieres eliminar esta categoría de widget?"
      },
      "messages": {
        "created": "Categoría de Widget creada exitosamente.",
        "updated": "Categoría de Widget actualizada exitosamente.",
        "deleted": "Categoría de Widget eliminada exitosamente."
      }
    },
    "widgetType": {
      "menuName": "Tipo de Widget",
      "pageTitle": "Tipo de Widget",
      "name": "Nombre",
      "types": {
        "number": "Número",
        "list": "Lista",
        "donut": "Dona",
        "line": "Línea"
      }
    },
    "widgetParameter": {
      "menuName": "Parámetro de Widget",
      "menuTitle": "Parámetro de Widget",
      "title": "Parámetro de Widget",
      "name": "Nombre",
      "nameInfo": "Nombre usado para identificar el parámetro en la consulta SQL del widget. No uses espacios o caracteres especiales.",
      "nameUniqueError": "Ya existe un Parámetro de Widget con este nombre.",
      "description": "Descripción",
      "isRequired": "¿Es Obligatorio?",
      "isMultiple": "¿Es Múltiple?",
      "status": "Estado",
      "edit": "Editar Parámetro de Widget",
      "add": "Agregar Parámetro de Widget",
      "type": "Tipo",
      "data": "Consulta SQL",
      "dataInfo": "La consulta SQL debe retornar dos columnas llamadas 'Value' y 'Text'.",
      "listOfValues": "Lista de Valores",
      "addValue": "Agregar Valor",
      "value": "Valor",
      "label": "Etiqueta",
      "delete": {
        "title": "Eliminar Parámetro de Widget",
        "text": "¿Estás seguro de que quieres eliminar {name}?"
      },
      "types": {
        "text": "Texto",
        "number": "Número",
        "date": "Fecha",
        "boolean": "Booleano",
        "select": "Lista",
        "sql": "Lista de Consulta"
      },
      "messages": {
        "notFound": "Parámetro de Widget no encontrado.",
        "saveSuccess": "Parámetro de Widget guardado exitosamente.",
        "saveError": "Ocurrió un error al guardar el Parámetro de Widget.",
        "deleteSuccess": "Parámetro de Widget eliminado exitosamente.",
        "deleteError": "Ocurrió un error al eliminar el Parámetro de Widget.",
        "isInUse": "No se puede eliminar el Parámetro de Widget porque está en uso."
      }
    },
    "people": {
      "menuName": "Personas",
      "pageTitle": "Personas",
      "employeeId": "ID de Empleado",
      "person": "Persona",
      "id": "Id",
      "name": "Nombre",
      "email": "Correo Electrónico",
      "externalId": "ID Externo",
      "status": "Estado",
      "type": "Tipo",
      "positionShortDescription": "Descripción breve del puesto",
      "hireDate": "Fecha de Contratación",
      "culture": "Cultura",
      "sourceJTPInstance": "Código JTP de Origen",
      "documentId": "ID de Documento",
      "manager": "Gerente",
      "position": "Puesto",
      "bonusFrequency": "Frecuencia de Bono",
      "businessArea": "Área de Negocio",
      "personnelArea": "Área de Personal",
      "division": "División",
      "plant": " Planta de Producción",
      "businessUnit": "Unidad de Negocio",
      "shiftId": "Turno",
      "plantAreaId": "Área de Planta",
      "customerSpecificStatus": "Estado Específico del Cliente",
      "vendorNumber": "Número de Proveedor",
      "accountNumber": "Últimos 4 Dígitos de Cuenta",
      "overrideManagerId": "Gerente Sustituto",
      "requirePrivacyConsent": "Empleado Global",
      "globalDirectReports": "Subordinados Directos Globales",
      "globalManagerOverrideHelpText": "Los empleados seleccionados reportarán a este empleado únicamente a escala global. Si este empleado tiene subordinados directos, todos serán marcados como globales también.",
      "messages": {
        "updated": "Persona actualizada correctamente.",
        "notFound": "Registro de persona no encontrado.",
        "alreadyExists": "Ya existe una persona con esta descripción.",
        "fileRequired": "El archivo es obligatorio.",
        "importError": "Ocurrió un error al importar las personas.",
        "importSuccess": "Personas importadas correctamente. Recibirás el archivo por correo electrónico.",
        "importFailed": "Error al importar personas.",
        "personNotFound": "Persona no encontrada para realizar la importación. Contacte al Administrador.",
        "emailNotFound": "Correo electrónico no encontrado para realizar la importación. Contacte al Administrador.",
        "importFalied": "La importación de personas falló."
      },
      "personTypes": {
        "unknown": "Desconocido",
        "salariedEmployee": "Empleado Asalariado",
        "contractor": "Contratista",
        "vendor": "Proveedor",
        "hourlyEmployee": "Empleado por Horas",
        "external": "Externo",
        "duHourlyInactive": "DU Por Horas Inactivo",
        "duSalariedInactive": "DU Asalariado Inactivo",
        "duTruckDriverIn": "DU Conductor de Camión Dentro",
        "executive": "Ejecutivo",
        "union": "Sindicalizado",
        "nonUnion": "No Sindicalizado",
        "unionPossible": "Sindicalización Posible",
        "salariedNonExempt": "Asalariado No Exento",
        "hourly": "Por Horas",
        "duPaidLeave": "DU Licencia Pagada",
        "truckDriver": "Conductor de Camión",
        "duUnpaidLeave": "DU Licencia Sin Goce de Sueldo",
        "workRelease": "Liberación de Trabajo",
        "externalAccessLevelOne": "Acceso Externo Nivel Uno",
        "externalAccessLevelTwo": "Acceso Externo Nivel Dos",
        "externalAccessLevelThree": "Acceso Externo Nivel Tres",
        "externalAccessLevelFour": "Acceso Externo Nivel Cuatro",
        "externalAccessLevelFive": "Acceso Externo Nivel Cinco",
        "globalEmployee": "Empleado Global"
      },
      "customerSpecificStatuses": {
        "unknown": "Desconocido",
        "active": "Activo",
        "inactive": "Inactivo",
        "incomeAssistance": "Asistencia económica",
        "lOA": "LOA",
        "retiree": "Jubilado",
        "withdrawn": "Retiro"
      }
    },
    "companyCode": {
      "menuName": "Códigos de Empresa"
    },
    "costCenter": {
      "menuName": "Centros de Costos"
    },
    "currency": {
      "menuName": "Monedas"
    },
    "exchangeRate": {
      "menuName": "Tipos de Cambio"
    }
  },
  "threeHundredSixty": {
    "menuTitle": "360",
    "questionOption": {
      "menuTitle": "Escalas de Calificación",
      "pageTitle": "Escalas de Calificación",
      "description": "Descripción",
      "add": "Agregar Escala de Calificación",
      "edit": "Editar Escala de Calificación",
      "delete": {
        "title": "Eliminar Escala de Calificación",
        "text": "¿Está seguro de que desea eliminar esta escala de calificación?"
      },
      "messages": {
        "notFound": "Escala de Calificación no encontrada.",
        "saveSuccess": "Escala de Calificación guardada correctamente.",
        "saveError": "Ocurrió un error al guardar la Escala de Calificación.",
        "deleteSuccess": "Escala de Calificación eliminada correctamente.",
        "deleteError": "Ocurrió un error al eliminar la Escala de Calificación.",
        "isInUse": "No se puede eliminar la Escala de Calificación porque está en uso.",
        "duplicateName": "Ya existe una Escala de Calificación con esta descripción."
      },
      "options": {
        "title": "Opciones",
        "value": "Valor",
        "description": "Descripción",
        "explanation": "Explicación",
        "itemOrder": "Orden",
        "color": "Color",
        "commentConfig": "Configuración de Comentarios",
        "add": "Agregar Opción",
        "edit": "Editar Opción",
        "delete": {
          "title": "Eliminar Opción",
          "text": "¿Está seguro de que desea eliminar esta opción?"
        },
        "messages": {
          "created": "Opción creada correctamente.",
          "updated": "Opción actualizada correctamente.",
          "deleted": "Opción eliminada correctamente.",
          "notFound": "Opción no encontrada.",
          "duplicateValue": "Dos o más opciones tienen el mismo valor. Cada opción debe tener un valor único.",
          "duplicateDescription": "Dos o más opciones tienen la misma descripción. Cada opción debe tener una descripción única."
        },
        "commentConfigType": {
          "followForm": "Seguir Formulario",
          "required": "Requerido",
          "notRequired": "No Requerido"
        }
      }
    },
    "questionGroup": {
      "menuTitle": "Grupos de Preguntas",
      "pageTitle": "Grupos de Preguntas",
      "name": "Nombre",
      "description": "Descripción",
      "add": "Agregar Grupo de Preguntas",
      "edit": "Editar Grupo de Preguntas",
      "delete": {
        "title": "Eliminar Grupo de Preguntas",
        "text": "¿Está seguro de que desea eliminar este grupo de preguntas: {name}?"
      },
      "messages": {
        "notFound": "Grupo de Preguntas no encontrado.",
        "saveSuccess": "Grupo de Preguntas guardado correctamente.",
        "saveError": "Ocurrió un error al guardar el Grupo de Preguntas.",
        "deleteSuccess": "Grupo de Preguntas eliminado correctamente.",
        "deleteError": "Ocurrió un error al eliminar el Grupo de Preguntas.",
        "isInUse": "No se puede eliminar el Grupo de Preguntas porque está en uso."
      }
    },
    "question": {
      "menuTitle": "Preguntas",
      "pageTitle": "Preguntas",
      "name": "Nombre",
      "weight": "Peso",
      "commentDisabled": "Comentario Deshabilitado",
      "description": "Descripción",
      "questionGroup": "Grupo de Preguntas",
      "questionOption": "Escala de Calificación",
      "add": "Agregar Pregunta",
      "edit": "Editar Pregunta",
      "delete": {
        "title": "Eliminar Pregunta",
        "text": "¿Está seguro de que desea eliminar esta pregunta?"
      },
      "messages": {
        "notFound": "Pregunta no encontrada.",
        "saveSuccess": "Pregunta guardada correctamente.",
        "saveError": "Ocurrió un error al guardar la Pregunta.",
        "deleteSuccess": "Pregunta eliminada correctamente.",
        "deleteError": "Ocurrió un error al eliminar la Pregunta.",
        "isInUse": "No se puede eliminar la Pregunta porque está en uso."
      }
    },
    "formCategory": {
      "menuTitle": "Categorías de Formulario",
      "pageTitle": "Categorías de Formulario",
      "name": "Nombre",
      "description": "Descripción",
      "add": "Agregar Categoría de Formulario",
      "edit": "Editar Categoría de Formulario",
      "delete": {
        "title": "Eliminar Categoría de Formulario",
        "text": "¿Está seguro de que desea eliminar esta categoría de formulario?"
      },
      "messages": {
        "notFound": "Categoría de Formulario no encontrada.",
        "saveSuccess": "Categoría de Formulario guardada correctamente.",
        "saveError": "Ocurrió un error al guardar la Categoría de Formulario.",
        "deleteSuccess": "Categoría de Formulario eliminada correctamente.",
        "deleteError": "Ocurrió un error al eliminar la Categoría de Formulario.",
        "isInUse": "No se puede eliminar la Categoría de Formulario porque está en uso."
      }
    },
    "formDelegate": {
      "menuTitle": "Delegado de Formulario",
      "pageTitle": "Delegado de Formulario",
      "form": "Formulario",
      "manager": "Gerente",
      "delegate": "Delegado",
      "add": "Agregar Delegado de Formulario",
      "edit": "Editar Delegado de Formulario",
      "delegatedToPerson": "Delegar a",
      "invitedEnabled": "Invitación Habilitada",
      "signEnabled": "Firma Habilitada",
      "resultViewerEnabled": "Visualizador de Resultados Habilitado",
      "delete": {
        "title": "Eliminar Delegado de Formulario",
        "text": "¿Estás seguro de que quieres eliminar este delegado de formulario?"
      },
      "messages": {
        "notFound": "Delegado de Formulario no encontrado.",
        "saveSuccess": "Delegado de Formulario guardado exitosamente.",
        "saveError": "Ocurrió un error al guardar el Delegado de Formulario.",
        "deleteSuccess": "Delegado de Formulario eliminado exitosamente.",
        "deleteError": "Ocurrió un error al eliminar el Delegado de Formulario.",
        "managerDisabledMessage": "No tienes acceso a este formulario"
      }
    },
    "formDelegateGlobal": {
      "menuTitle": "Delegado de Formulario Global",
      "pageTitle": "Delegado de Formulario Global"
    },
    "form": {
      "menuTitle": "Formularios",
      "pageTitle": "Formularios",
      "id": "Id",
      "description": "Descripción",
      "category": "Categoría",
      "categoryId": "Categoría",
      "stage": {
        "label": "Escenario",
        "preparation": "Preparación",
        "execution": "Ejecución",
        "managerReview": "Revisión del gerente",
        "participantReview": "Revisión del participante",
        "closed": "Cerrado"
      },
      "active": "Activo",
      "maximumHireDate": "Fecha máxima de contratación",
      "maxPeopleEvaluateAlert": "Alerta de máximo de personas a evaluar",
      "includeGlobalReporting": "Informes globales",
      "customerSpecificStatus": "Estatus específico del cliente",
      "employeeType": "Tipo de empleado",
      "reportType": {
        "label": "Tipo de reporte",
        "question": "Por Pregunta",
        "questionGroup": "Por Grupo de preguntas"
      },
      "directReportBox": "Evaluación de colaboradores directos",
      "selfEvaluationBox": "Autoevaluación",
      "managerEvaluationBox": "Evaluación del gerente",
      "crossGroupEvaluationBox": "Evaluación entre grupos cruzados",
      "freeEvaluationBox": "Evaluación libre",
      "dueDatesBox": "Fecha límite",
      "evaluation": "Evaluación",
      "comments": "Comentarios",
      "weight": "Peso",
      "minCrossGroupEvaluations": "Mínimo de evaluaciones de grupos cruzados",
      "crossGroupDueDate": "Crear Cross Group – Propio",
      "evaluationDueDate": "Crear Cross Group – Gerente",
      "managerSignDueDate": "Final Cross Group – Gerente",
      "participantSignDueDate": "Fecha de Cierre",
      "processDueDate": "Evaluación",
      "beginningReviewDate": "Periodo de revisión inicial",
      "endingReviewDate": "Finalizando el periodo de revisión",
      "maxReleaseQuestionnaireDate": "Publicación del cuestionario",
      "createdBy": "Creado por",
      "createdDate": "Fecha de creación",
      "modifiedBy": "Modificado por",
      "modifiedDate": "Fecha de modificación",
      "maximumHireDateHelpText": "Fecha de contratación máxima del empleado para participar, excepto si el empleado es un gerente.",
      "maxPeopleEvaluateAlertHelpText": "Mostrar una alerta después de que el empleado alcance el número máximo de personas a evaluar.",
      "includeGlobalReportingHelpText": "Incluir en informes globales",
      "directReportEvaluationHelpText": "Evaluación de colaboradores directos",
      "directReportCommentsHelpText": "Comentarios de colaboradores directos",
      "directReportWeightHelpText": "Peso de colaborador directo",
      "selfEvaluationHelpText": "Autoevaluación",
      "selfCommentsHelpText": "Comentarios propios",
      "selfWeightHelpText": "Peso propio",
      "managerEvaluationHelpText": "Evaluación del gerente",
      "managerCommentsHelpText": "Comentarios del gerente",
      "managerWeightHelpText": "Peso del gerente",
      "freeCommentsHelpText": "Comentarios libres",
      "freeWeightHelpText": "Peso libre",
      "crossGroupEvaluationHelpText": "Evaluación entre grupos cruzados",
      "crossGroupCommentsHelpText": "Comentarios de grupos cruzados",
      "crossGroupWeightHelpText": "Peso de grupo cruzado",
      "minCrossGroupEvaluationsHelpText": "Número mínimo de evaluaciones entre grupos para permitir que el gerente publique el cuestionario.",
      "maxReleaseQuestionnaireDateHelpText": "Fecha máxima para que el gerente publique el cuestionario",
      "add": "Agregar Formulario",
      "edit": "Editar Formulario",
      "updateCounters": "Actualizar contadores",
      "detailedResult": "Resultado detallado",
      "move": {
        "button": "Mover a {stage}",
        "title": "Mover etapa",
        "text": "¿Está seguro de mover este formulario al escenario {stage}?"
      },
      "duplicate": {
        "button": "Duplicar",
        "title": "Duplicar Formulario",
        "text": "¿Está seguro de que desea duplicar este formulario?"
      },
      "delete": {
        "title": "Eliminar Formulario",
        "text": "¿Está seguro de que desea eliminar este formulario: {name}?"
      },
      "formQuestion": {
        "title": "Preguntas del formulario",
        "question": "Pregunta",
        "itemOrder": "Orden",
        "questionGroup": "Grupo de preguntas",
        "add": "Agregar Pregunta",
        "edit": "Editar Pregunta",
        "delete": {
          "title": "Eliminar Pregunta",
          "text": "¿Está seguro de que desea eliminar {name} de este formulario?"
        },
        "messages": {
          "saveSuccess": "Pregunta del formulario guardada correctamente.",
          "saveError": "Ocurrió un error al guardar la Pregunta del Formulario.",
          "deleteSuccess": "Pregunta del formulario eliminada correctamente.",
          "deleteError": "Ocurrió un error al eliminar la Pregunta del Formulario.",
          "duplicateQuestion": "Esta pregunta ya ha sido agregada al formulario.",
          "notFound": "Pregunta del formulario no encontrada.",
          "questionNotFound": "Pregunta no encontrada."
        }
      },
      "messages": {
        "notFound": "Formulario no encontrado.",
        "saveSuccess": "Formulario guardado correctamente.",
        "saveError": "Ocurrió un error al guardar el Formulario.",
        "deleteSuccess": "Formulario eliminado correctamente.",
        "deleteError": "Ocurrió un error al eliminar el Formulario.",
        "isInUse": "No se puede eliminar el Formulario porque está en uso.",
        "atLeastOneMemberEvaluate": "Al menos uno de estos grupos de campos debe estar activo: Evaluación de colaborador directo, autoevaluación, evaluación entre grupos o evaluación de gerente.",
        "maximumHireDateRequired": "La fecha máxima de contratación es obligatoria.",
        "dueDatesRequired": "Todas las fechas límite son obligatorias.",
        "moveStageSuccess": "Formulario movido a la siguiente etapa correctamente.",
        "moveStageNotAllowed": "No se puede mover un formulario cerrado a otra etapa.",
        "moveStageNotAllowedNoPeople": "El formulario no tiene personas. Para moverse, visite la página de Personas del Formulario para incluir personas en este formulario.",
        "moveStageNotAllowedNoQuestions": "El formulario no tiene preguntas. Para moverlo, inserte al menos una pregunta.",
        "duplicateSuccess": "Formulario duplicado correctamente.",
        "updateCountersSuccess": "La actualización de los contadores ha sido activada.",
        "detailedResultSuccess": "La generación del resultado detallado ha sido activada."
      }
    },
    "formEmailSender": {
      "menuTitle": "Remitente de correo electrónico",
      "pageTitle": "Remitente de correo electrónico",
      "messages": {
        "emailsSent": "Correos electrónicos enviados exitosamente."
      }
    },
    "questionnaire": {
      "questionnaireTypes": {
        "manager": "Gerente",
        "directReport": "Reporte directo",
        "crossGroup": "Grupo cruzado",
        "selfEvaluation": "Autoevaluación",
        "freeEvaluation": "Evaluación libre"
      },
      "questionnaireRequestTypes": {
        "default": "Predeterminado",
        "manager": "Gerente",
        "directReport": "Empleado"
      },
      "questionnaireStatus": {
        "done": "Completado",
        "declined": "Rechazado",
        "open": "Abierto"
      },
      "questionnairePriorityTypes": {
        "selfDirectManager": "Autoevaluación, Reporte Directo y Gerente",
        "crossGroupPeers": "Grupo Cruzado (Pares)",
        "crossGroup": "Grupos Cruzados",
        "freeEvaluation": "Evaluación Libre"
      },
      "questionnairesReport": {
        "title": "Informe de Cuestionarios",
        "messages": {
          "confirm": "El archivo será exportado. Recibirás los resultados por correo electrónico pronto.",
          "success": "La exportación del informe de cuestionarios ha sido activada. Recibirás los resultados por correo electrónico pronto.",
          "emailNotFound": "Correo electrónico no encontrado para realizar la exportación. Contacta al administrador.",
          "formNotFound": "Formulario no encontrado para realizar la exportación. Contacta al administrador.",
          "exportFailed": "Error al exportar el informe de cuestionarios."
        }
      },
      "createCrossGroupForMyself": {
        "menuTitle": "Crear un Grupo Cruzado para mí",
        "pageTitle": "Crear un Grupo Cruzado para mí",
        "form": "Formulario",
        "infoMessage": " A continuación se muestra tu cross group predeterminado. Agrega empleados adicionales por los que te gustaría ser evaluado. Debes tener al menos cinco del tipo \"cross group\". Tu gerente revisará, actualizará según corresponda y liberará los cuestionarios.",
        "warningReleasedQuestionnaires": "No puede agregar grupos cruzados porque su gerente ya publicó cuestionarios sobre usted. Por favor, hable con él sobre cómo agregar más cuestionarios.",
        "add": "Agregar Empleado",
        "evaluatorPerson": "Evaluador",
        "manager": "Gerente",
        "type": "Tipo",
        "requestType": "Solicitado por",
        "released": "Publicado",
        "status": "Estado",
        "actions": "Acciones",
        "delete": {
          "title": "Eliminar cuestionario",
          "text": "¿Está seguro de que desea eliminar este cuestionario?"
        },
        "messages": {
          "alreadyExists": "Este cuestionario ya existe para {names}. Si tiene alguna pregunta, hable con su gerente.",
          "addSuccess": "Cuestionarios creados correctamente.",
          "deleteSuccess": "Cuestionario eliminado correctamente.",
          "invitedPersonWarning": "{names} ya ha sido invitado a proporcionar retroalimentación 360 en al menos {limit} otros formularios. Para incluirlos en formularios adicionales, seleccione «Guardar». Si su retroalimentación no es esencial, cierre sin guardar y seleccione a otra persona."
        }
      },
      "crossGroupForMyTeam": {
        "menuTitle": "Crear Grupos Cruzados para Mi Equipo",
        "pageTitle": "Crear Grupos Cruzados para Mi Equipo",
        "form": "Formulario",
        "manager": "Gerente",
        "evaluatedPerson": "Evaluado",
        "evaluatorPerson": "Evaluador",
        "type": "Tipo",
        "released": "Liberado",
        "status": "Estado",
        "loadCrossGroupDefaults": "Cargar Valores Predeterminados de Grupos Cruzados",
        "unloadCrossGroupDefaults": "Descargar Valores Predeterminados de Grupos Cruzados",
        "releaseQuestionnaire": "Liberar Cuestionarios",
        "add": "Agregar Cuestionario",
        "delete": {
          "title": "Eliminar Cuestionario",
          "text": "¿Estás seguro de que deseas eliminar este cuestionario?"
        },
        "messages": {
          "alreadyExists": "Este cuestionario ya existe para {names}.",
          "createdSuccess": "Cuestionarios creados exitosamente.",
          "deletedSuccess": "Cuestionario eliminado exitosamente.",
          "saveError": "Ocurrió un error al guardar el cuestionario. Por favor, intenta de nuevo.",
          "questionnairesAlreadyExists": "Los cuestionarios ya existen para: {names}.",
          "managerDisabledMessage": "No tienes acceso a este formulario de grupo cruzado",
          "releasedSuccess": "Cuestionarios liberados exitosamente.",
          "minCrossGroupEvaluations": "Solo se muestran personas con al menos {value} cuestionarios de grupo cruzado.",
          "noQuestionnairesToRelease": "No hay cuestionarios para liberar. Por favor, agrega al menos un cuestionario para liberar.",
          "isReadOnlyDueStage": "Este formulario es de solo lectura y no se puede editar",
          "remoteInstanceWarning": "Ocurrió un problema al cargar la información remota.",
          "minimumCrossGroupsNotMet": "El empleado no tiene el número mínimo de grupos cruzados ({current}/{minimum})",
          "questionnairesReleased": "Cuestionarios liberados",
          "readyForRelease": "Listo para liberar"
        },
        "crossGroupDefaults": {
          "loadDefaults": {
            "title": "Cargar Valores Predeterminados de Grupos Cruzados",
            "messages": {
              "confirm": "ADVERTENCIA: Por favor, confirma que deseas cargar los participantes predeterminados de grupos cruzados para todos tus reportes directos.",
              "success": "Participantes predeterminados de grupos cruzados cargados exitosamente."
            }
          },
          "unloadDefaults": {
            "title": "Descargar Valores Predeterminados de Grupos Cruzados",
            "messages": {
              "confirm": "Por favor, confirma que deseas descargar los participantes predeterminados de grupos cruzados para todos tus reportes directos.",
              "success": "Participantes predeterminados de grupos cruzados descargados exitosamente."
            }
          }
        }
      },
      "crossGroupForMyRemoteTeam": {
        "menuTitle": "Crear Grupos Cruzados para Mi Equipo Remoto",
        "pageTitle": "Crear Grupos Cruzados para Mi Equipo Remoto"
      },
      "complete": {
        "menuTitle": "Completar Cuestionario",
        "pageTitle": "Completar Cuestionario",
        "form": "Formulario",
        "questionnaireType": "Tipo de Cuestionario",
        "submit": "Enviar",
        "notApplicable": "N/A",
        "reopen": "Reabrir",
        "status": {
          "new": "Cuestionario no iniciado",
          "inProgress": "Cuestionario en progreso",
          "completed": "Cuestionario completado"
        },
        "notApplicableTitle": "Rechazar cuestionario",
        "reopenTitle": "Confirmar retirada",
        "addFreeEvaluation": "Agregar Evaluación Libre",
        "personToEvaluate": "Persona a Evaluar",
        "freeEvaluationWarning": "Las Evaluaciones Libres deberán ser aprobadas por los gerentes y no contribuyen a las puntuaciones generales del 360.",
        "messages": {
          "loading": "Cargando cuestionarios...",
          "loadingGlobalQuestionnaires": "Cargando cuestionarios globales...",
          "formNotFound": "Formulario no encontrado.",
          "employeeNotFound": "Empleado no encontrado.",
          "freeEvaluationNotAllowed": "No puede agregar una evaluación libre para usted mismo, su gerente, sus compañeros o sus reportes directos.",
          "alreadyExists": "Ya existe una evaluación para esta persona.",
          "submitConfirmation": "Al hacer clic en enviar, la calificación del empleado mostrado es lo que se registrará. Puedes retirar las evaluaciones enviadas hasta que el proceso 360 avance a la firma del gerente.",
          "summaryValidate": "Valida las respuestas y desplázate hacia abajo para enviar. Hacer clic en la X de la esquina superior derecha no finalizará tu envío.",
          "submitSuccess": "Cuestionario enviado exitosamente.",
          "questionnaireNotFound": "Cuestionario no encontrado.",
          "notSubmittedWarningMessage": "Este cuestionario aún no ha sido enviado y no está siendo considerado en la puntuación del empleado.",
          "noQuestionnaires": "No tiene ningún cuestionario para completar.",
          "selectQuestionnaire": "Seleccione un cuestionario para completar.",
          "employeeRateSummary": "Tasa del Empleado: ",
          "notApplicable": "Si usted no es la persona adecuada para completar esta revisión de desempeño, puede rechazar la responsabilidad, después de proporcionar un motivo.",
          "declineSuccess": "Cuestionario rechazado exitosamente.",
          "requiredQuestionnairesCompleted": "Todas las evaluaciones restantes pueden completarse a su discreción.",
          "allQuestionsRequired": "Todas las preguntas y comentarios son obligatorios para poder enviar.",
          "confirmReopen": "¿Está seguro de que desea retirar la evaluación de {name}?",
          "reopenSuccess": "Cuestionario reabierto exitosamente.",
          "questionnaireAlreadySubmitted": "Este cuestionario ya ha sido enviado y no puede ser editado.",
          "addFreeEvaluationSuccess": "Evaluación libre agregada exitosamente."
        }
      },
      "freeEvaluation": {
        "menuTitle": "Revisión de Evaluación Libre",
        "menuTitleGlobal": "Revisión Global de Evaluación Libre",
        "pageTitle": "Revisión de Evaluación Libre",
        "pageTitleGlobal": "Revisión Global de Evaluación Libre",
        "evaluatedPerson": "Evaluado",
        "view": "Ver Cuestionario",
        "infoMessage": "Revise los cuestionarios a continuación y apruebe los que esté de acuerdo. Si no aprueba un cuestionario, no se requiere ninguna acción adicional.",
        "messages": {
          "confirmApproval": "¿Está seguro de que desea aprobar el cuestionario?",
          "approvalSuccess": "Cuestionario aprobado exitosamente.",
          "notFound": "Cuestionario no encontrado."
        }
      }
    },
    "formPeople": {
      "participants": {
        "menuTitle": "Participantes del Formulario",
        "pageTitle": "Participantes del Formulario",
        "formId": "Formulario",
        "resetTree": "Restablecer arbol",
        "resetTreeTitle": "Restablecer arbol",
        "resetTreeText": "Estas seguro de que deseas restablecer el arbol?",
        "addPerson": "Agregar participante",
        "changeManager": "Cambiar gerente",
        "downloadTemplate": "Descargar plantilla",
        "import": "Importar",
        "person": "Empleado",
        "currentManager": "Gerente actual",
        "newManager": "Nuevo gerente",
        "messages": {
          "noNodeSelected": "Debes seleccionar al menos un empleado.",
          "saveSuccess": "Participantes del formulario guardados exitosamente.",
          "resetSuccess": "Participantes del formulario restablecidos exitosamente.",
          "formNotFound": "Formulario no encontrado.",
          "selectEmployee": "Selecciona primero un empleado",
          "addPersonSuccess": "Participante agregado exitosamente.",
          "changeManagerSuccess": "Gerente cambiado exitosamente.",
          "moveToManagerSuccess": "Persona movida al nuevo gerente exitosamente.",
          "managerNotInTree": "El gerente seleccionado no está en el árbol.",
          "circularManagerSelection": "No se puede mover a un empleado hacia uno de sus propios subordinados.",
          "importSuccess": "Archivo importado exitosamente. Recibiras los resultados por correo pronto."
        },
        "errors": {
          "formInExecution": "Esta accion no se puede realizar porque el formulario esta actualmente en ejecucion."
        }
      },
      "resultViewer": {
        "menuTitle": "Informes PDF aprobados",
        "pageTitle": "Informes PDF aprobados",
        "person": "Persona",
        "personHelpText": "Puede seleccionar a usted mismo o a cualquiera de sus reportes directos.",
        "personMultipleInstance": "No seleccione empleados de varias instancias. Los resultados pueden ser incorrectos o incompletos.",
        "manager": "Gerente",
        "form": "Formulario",
        "position": "Puesto",
        "managerFeedback": "Retroalimentacion del gerente",
        "employeeFeedback": "Retroalimentacion del empleado",
        "pdfReport": "Informe PDF",
        "pdfReportFreeEvaluation": "PDF de evaluacion libre",
        "pdfReportFreeEvaluationNonApproved": "PDF de evaluacion libre no aprobada",
        "downloadSelected360Report": "Descargar informe 360 seleccionado",
        "downloadSelectedFreeEvaluationReport": "Descargar informe de evaluacion libre seleccionado",
        "downloadSelectedNonApprovedFreeEvaluationReport": "Descargar informe de evaluacion libre no aprobada seleccionado",
        "emailSelected360Report": "Enviar por correo el informe 360 seleccionado",
        "emailSelectedFreeEvaluationReport": "Enviar por correo el informe de evaluacion libre seleccionado",
        "emailSelectedNonApprovedFreeEvaluationReport": "Enviar por correo el informe de evaluacion libre no aprobada seleccionado",
        "bulkEmailQueued": "Sus informes se estan preparando. Recibira un correo con los archivos PDF adjuntos en breve.",
        "bulkEmailNoSelection": "Seleccione al menos una fila.",
        "bulkEmailInvalidSelection": "Una o mas filas seleccionadas no son validas para su acceso.",
        "bulkEmailNoReportForKind": "Las filas seleccionadas no incluyen este tipo de informe.",
        "showFeedback": "Mostrar retroalimentacion",
        "downloadEvaluationSelectOne": "Seleccione una persona o un gerente.",
        "validationSelectPersonOrManager": "Seleccione una persona o un gerente para ejecutar el filtro.",
        "successPdfByEmail": "El PDF se envio correctamente a su correo."
      },
      "sign": {
        "menuTitle": "Firmar Evaluaciones",
        "pageTitle": "Firmar Evaluaciones",
        "menuTitleGlobal": "Firmar Evaluaciones Globales",
        "pageTitleGlobal": "Firmar Evaluaciones Globales",
        "form": "Formulario",
        "managerOrPerson": "Gerente/Persona",
        "person": "Persona",
        "pdfReport": "Reporte PDF",
        "pdfReportFreeEvaluation": "Reporte PDF de Evaluaciones Libres",
        "sign": "Firmar",
        "signed": "Firmado",
        "signTitle": "Firmar Evaluación",
        "managerSign": "Firma del Gerente",
        "personSign": "Firma del empleado",
        "signatureComments": "Comentarios de la Firma",
        "updateComment": "Actualizar Comentario",
        "messages": {
          "signedBy": "Firmado por {name} el {date}",
          "signConfirmationManager": "Cualquier información adicional respecto al proceso de retroalimentación con tu colaborador directo puede ser proporcionada a continuación.",
          "signConfirmationPerson": "Al seleccionar firmar, confirmas que tuviste una conversación de retroalimentación con tu gerente sobre la evaluación.",
          "signConfirmationWarning": "Al seleccionar firmar, el PDF será liberado al empleado.",
          "managerSignatureNotAllowed": "No puedes firmar esta evaluación porque el gerente ya la firmó.",
          "employeeSignatureNotAllowed": "No puedes firmar esta evaluación porque la persona ya la firmó.",
          "successMessage": "Evaluación firmada exitosamente.",
          "updateCommentSuccessMessage": "Comentario actualizado exitosamente.",
          "noComments": "Debes proporcionar comentarios antes de firmar."
        }
      }
    }
  },
  "security": {
    "menuTitle": "Seguridad",
    "resource": {
      "menuName": "Recurso",
      "pageTitle": "Recurso",
      "add": "Agregar recurso",
      "edit": "Editar recurso",
      "delete": {
        "title": "Eliminar recurso",
        "text": "¿Está seguro de que desea eliminar este recurso?"
      },
      "id": "Id",
      "name": "Nombre",
      "description": "Descripción",
      "resourceType": "Tipo de recurso",
      "isActive": "Está activo",
      "messages": {
        "created": "Recurso creado correctamente.",
        "updated": "Recurso actualizado correctamente.",
        "deleted": "Recurso eliminado correctamente.",
        "notFound": "Registro de recurso no encontrado",
        "duplicateName": "Ya existe un recurso con este nombre.",
        "inUse": "El recurso está en uso. Elimine primero sus usos."
      }
    },
    "user": {
      "menuName": "Usuario",
      "pageTitle": "Usuario",
      "subgridName": "Cuenta de usuario",
      "uniqueId": "Id único",
      "add": "Agregar cuenta de usuario",
      "edit": "Editar cuenta de usuario",
      "delete": {
        "title": "Eliminar cuenta de usuario",
        "text": "¿Está seguro de que desea eliminar esta cuenta?"
      },
      "personId": "Id",
      "provider": "Proveedor",
      "userName": "Nombre de usuario",
      "isActive": "Está activo",
      "messages": {
        "created": "Cuenta de usuario creada correctamente.",
        "updated": "Cuenta de usuario actualizada correctamente.",
        "deleted": "Cuenta de usuario eliminada correctamente.",
        "notFound": "Registro de cuenta no encontrado",
        "duplicateName": "Este nombre de usuario ya existe."
      }
    },
    "group": {
      "menuName": "Grupo",
      "pageTitle": "Grupo",
      "add": "Agregar grupo",
      "edit": "Editar grupo",
      "delete": {
        "title": "¿Eliminar grupo?",
        "text": "¿Está seguro de que desea eliminar este grupo?"
      },
      "id": "Id",
      "name": "Nombre",
      "description": "Descripción",
      "isActive": "Está activo",
      "overwriteGroups": "Sobrescribir grupos",
      "messages": {
        "created": "Grupo creado correctamente.",
        "updated": "Grupo actualizado correctamente.",
        "deleted": "Grupo eliminado correctamente.",
        "notFound": "Registro de grupo no encontrado",
        "duplicateName": "Ya existe un grupo con este nombre.",
        "fileRequired": "El archivo es obligatorio.",
        "imported": "Los grupos fueron importados correctamente"
      }
    },
    "groupPeople": {
      "menuName": "Personas del grupo",
      "pageTitle": "Personas del grupo",
      "add": "Agregar personas al grupo",
      "edit": "Editar personas del grupo",
      "delete": {
        "title": "Eliminar personas del grupo",
        "text": "¿Está seguro de que desea eliminar este registro?"
      },
      "groupId": "Grupo",
      "personId": "Persona",
      "validityStart": "Inicio de vigencia",
      "validityEnd": "Fin de vigencia",
      "messages": {
        "created": "Persona de grupo creada correctamente.",
        "updated": "Persona de grupo actualizada correctamente.",
        "deleted": "Persona de grupo eliminada correctamente.",
        "notFound": "Registro no encontrado",
        "alreadyExists": "El usuario ya usa este grupo."
      }
    },
    "groupPermission": {
      "menuName": "Permisos de grupo",
      "pageTitle": "Permisos de grupo",
      "add": "Agregar permiso de grupo",
      "edit": "Editar permiso de grupo",
      "delete": {
        "title": "Eliminar permiso de grupo",
        "text": "¿Está seguro de que desea eliminar este permiso?"
      },
      "groupId": "Grupo",
      "resourceId": "Recurso",
      "action": "Acción",
      "messages": {
        "created": "Permiso creado correctamente.",
        "updated": "Permiso actualizado correctamente.",
        "deleted": "Permiso eliminado correctamente.",
        "notFound": "Registro no encontrado",
        "duplicateName": "Ya existe este permiso para el recurso."
      }
    }
  },
  "goals": {
    "menuName": "Metas",
    "kpi": {
      "menuName": "KPI"
    },
    "plan": {
      "menuName": "Planes"
    },
    "target": {
      "menuName": "Objetivos",
      "kpiOwner": {
        "menuName": "Objetivos - Propietario del KPI"
      }
    },
    "actual": {
      "menuName": "Actualización de datos",
      "kpiOwner": {
        "menuName": "Actualización de datos - Propietario del KPI"
      }
    },
    "discussionNotes": {
      "menuName": "Notas de Discusión"
    },
    "flexibleGoal": {
      "menuName": "Objetivo Flexible"
    },
    "actionPlan": {
      "menuName": "Planes de Acción"
    },
    "library": {
      "menuName": "Biblioteca"
    },
    "category": {
      "menuName": "Categoría"
    },
    "PlantArea": {
      "menuName": "Área de Planta"
    },
    "clerks": {
      "menuName": "Propietarios de KPI"
    },
    "quickEntry": {
      "menuName": "Entrada Rápida Anual"
    }
  },
  "nineBox": {
    "menuName": "Matriz 9",
    "nineBoxForm": {
      "menuName": "Formulario"
    },
    "nineBoxFormPeople": {
      "menuName": "Participantes del Formulario"
    },
    "fillTalentTalk": {
      "menuName": "Completar Conversación de Talento"
    },
    "nineBoxCalibration": {
      "menuName": "Calibración"
    },
    "fillDevelopmentPlan": {
      "menuName": "Completar Plan de Desarrollo"
    }
  },
  "pcf": {
    "menuName": "PCF",
    "dashboard": {
      "menuName": "Panel"
    },
    "request": {
      "newPCF": {
        "menuName": "Nuevo PCF"
      }
    },
    "requestType": {
      "menuName": "Tipo de Solicitud"
    },
    "approvalGroup": {
      "menuName": "Grupo de Aprobación"
    },
    "requestStatuses": {
      "menuName": "Estados de Solicitud"
    },
    "catalog": {
      "menuName": "Catálogo"
    }
  },
  "merit": {
    "menuName": "Mérito",
    "meritPlanFormList": {
      "menuName": "Participantes del Formulario"
    },
    "meritDashboard": {
      "menuName": "Panel"
    },
    "meritPlan": {
      "menuName": "Plan"
    },
    "awardLetter": {
      "menuName": "Carta de Premios"
    },
    "meritPlanParticipants": {
      "menuName": "Participantes del Plan"
    }
  },
  "bonus": {
    "menuName": "Bonificación",
    "bonusIncentiveGroup": {
      "menuName": "Grupo de Incentivos"
    },
    "bonusPlan": {
      "menuName": "Plan"
    },
    "bonusPlanParticipants": {
      "menuName": "Participantes del Plan"
    },
    "bonusDashboard": {
      "menuName": "Panel"
    },
    "awardLetter": {
      "menuName": "Carta de Premios"
    }
  },
  "cultureTalent": {
    "menuName": "Cultura y Talento",
    "culture": {
      "menuName": "Programas de Cultura y Talento"
    },
    "talent": {
      "menuName": "Plataformas de Capacitación"
    }
  },
  "talentMapping": {
    "menuName": "Mapeo de Talento",
    "skills": {
      "menuName": "Habilidades"
    },
    "orgChart": {
      "menuName": "Organigrama"
    },
    "myProfile": {
      "menuName": "Mi perfil"
    },
    "degreeTypes": {
      "menuName": "Tipo de Titulación",
      "pageTitle": "Tipo de Titulación",
      "name": "Nombre",
      "isActive": "Está Activo",
      "add": "Agregar Tipo de Titulación",
      "edit": "Editar Tipo de Titulación",
      "delete": {
        "title": "Eliminar Tipo de Titulación",
        "text": "¿Está seguro de que desea eliminar este Tipo de Titulación?"
      },
      "messages": {
        "created": "Tipo de Titulación creado con éxito.",
        "updated": "Tipo de Titulación actualizado con éxito.",
        "deleted": "Tipo de Titulación eliminado con éxito.",
        "saveError": "Ocurrió un error al guardar el Tipo de Titulación. Por favor, intente nuevamente.",
        "notFound": "Registro de Tipo de Titulación no encontrado.",
        "inUse": "El Tipo de Titulación está en uso y no puede eliminarse."
      }
    }
  },
  "absenceRequest": {
    "menuName": "Solicitud de Ausencia",
    "createRequest": {
      "menuName": "Crear Solicitud"
    },
    "viewManageRequests": {
      "menuName": "Mis Solicitudes"
    },
    "calendar": {
      "menuName": "Calendario"
    },
    "pendingRequestsAndHistory": {
      "menuName": "Aprobaciones"
    },
    "manageDirectReportsHours": {
      "menuName": "Mantener Saldos"
    },
    "upload": {
      "menuName": "Cargar"
    },
    "manageAbsenceProfiles": {
      "menuName": "Administrar Perfiles de Ausencia"
    },
    "manageHolidays": {
      "menuName": "Administrar Días Festivos"
    },
    "hoursCalculationMatrices": {
      "menuName": "Matrices de Cálculo de Horas"
    },
    "manageApprovingDelegate": {
      "menuName": "Delegar Aprobaciones"
    },
    "notification": {
      "menuName": "Notificación de Ausencia"
    },
    "manageMatrixCategories": {
      "menuName": "Administrar Categorías de Matriz"
    },
    "manageFloatingHolidayMatrix": {
      "menuName": "Administrar Matriz de Días Festivos Flotantes"
    },
    "manageSickMatrix": {
      "menuName": "Administrar Matriz de Enfermedad"
    }
  },
  "expenseReport": {
    "menuName": "Reportes de Gastos",
    "createExpenses": {
      "menuName": "Crear Solicitud"
    },
    "myExpenses": {
      "menuName": "Mis Solicitudes"
    },
    "approvals": {
      "menuName": "Gastos para Aprobar"
    },
    "delegateApprovals": {
      "menuName": "Delegar Aprobaciones"
    },
    "preparers": {
      "menuName": "Preparadores"
    },
    "categories": {
      "menuName": "Categorías"
    },
    "distanceRates": {
      "menuName": "Tarifas de Distancia"
    },
    "generalLedgers": {
      "menuName": "Libros Mayores Generales"
    },
    "policies": {
      "menuName": "Políticas"
    },
    "projects": {
      "menuName": "Proyectos"
    }
  },
  "salaryExtraPay": {
    "menuName": "Pago Extra de Salario 6to/7mo Día",
    "createRequest": {
      "menuName": "Crear Solicitud"
    },
    "myRequests": {
      "menuName": "Mis Solicitudes"
    },
    "approvals": {
      "menuName": "Aprobaciones"
    },
    "delegateApprovals": {
      "menuName": "Delegar Aprobaciones"
    },
    "locationSetups": {
      "menuName": "Configuraciones de Ubicación"
    },
    "export": {
      "menuName": "Exportar"
    },
    "policies": {
      "menuName": "Políticas"
    },
    "payType": {
      "menuName": "Tipos de Pago"
    },
    "personnelAreaSetups": {
      "menuName": "Configuraciones de Área de Personal"
    }
  },
  "developmentPlan": {
    "menuName": "Plan de Desarrollo",
    "planDelegate": {
      "menuName": "Delegado del Plan"
    },
    "questions": {
      "menuName": "Preguntas"
    },
    "plans": {
      "menuName": "Planes"
    },
    "programs": {
      "menuName": "Programas"
    },
    "notificationSender": {
      "menuName": "Remitente de Notificación"
    },
    "fillDevelopmentPlan": {
      "menuName": "Completar Plan de Desarrollo"
    },
    "signEvaluations": {
      "menuName": "Firmar Evaluaciones"
    },
    "resultViewer": {
      "menuName": "Visor de Resultados"
    }
  },
  "survey": {
    "menuName": "Encuesta",
    "questionCategories": {
      "menuName": "Categorías de Preguntas"
    },
    "questions": {
      "menuName": "Preguntas"
    },
    "ratingScales": {
      "menuName": "Escalas de Calificación"
    },
    "actionPlans": {
      "menuName": "Plan de Acción"
    },
    "people": {
      "menuName": "Personas"
    },
    "surveys": {
      "menuName": "Formularios de Encuesta"
    },
    "notificationSender": {
      "menuName": "Remitente de Notificación"
    },
    "dashboard": {
      "menuName": "Panel"
    }
  },
  "hourlyPositions": {
    "menuName": "Puestos por Hora",
    "createRequest": {
      "menuName": "Crear Solicitud"
    },
    "requests": {
      "menuName": "Solicitudes"
    },
    "employeeSubgroup": {
      "menuName": "Subgrupo de Empleados"
    },
    "hourlyCatalog": {
      "menuName": "Catálogo por Hora"
    }
  },
  "vuestic": {
    "search": "Buscar",
    "noOptions": "Elementos no encontrados",
    "ok": "OK",
    "cancel": "Cancelar",
    "uploadFile": "Seleccionar archivo",
    "undo": "Deshacer",
    "dropzone": "Arrastra los archivos aquí para cargar",
    "fileDeleted": "Archivo eliminado",
    "closeAlert": "cerrar alerta",
    "backToTop": "regresar arriba",
    "toggleDropdown": "alternar menú desplegable",
    "carousel": "carrusel",
    "goPreviousSlide": "ir a la diapositiva anterior",
    "goNextSlide": "ir a la siguiente diapositiva",
    "goSlide": "ir a la diapositiva {index}",
    "slideOf": "diapositiva {index} de {length}",
    "close": "cerrar",
    "openColorPicker": "abrir selector de color",
    "colorSelection": "selección de color",
    "colorName": "color {color}",
    "decreaseCounter": "disminuir contador",
    "increaseCounter": "aumentar contador",
    "selectAllRows": "seleccionar todas las filas",
    "sortColumnBy": "ordenar columna por {name}",
    "selectRowByIndex": "seleccionar fila {index}",
    "resetDate": "restablecer fecha",
    "nextPeriod": "siguiente período",
    "switchView": "cambiar vista",
    "previousPeriod": "período anterior",
    "removeFile": "quitar archivo",
    "reset": "restablecer",
    "pagination": "paginación",
    "goToTheFirstPage": "ir a la primera página",
    "goToPreviousPage": "ir a la página anterior",
    "goToSpecificPage": "ir a la página {page}",
    "goToSpecificPageInput": "ingresar número de página",
    "goNextPage": "ir a la siguiente página",
    "goLastPage": "ir a la última página",
    "currentRating": "calificación actual {value} de {max}",
    "voteRating": "votar calificación {value} de {max}",
    "optionsFilter": "filtro de opciones",
    "splitPanels": "dividir paneles",
    "movePaginationLeft": "mover paginación a la izquierda",
    "movePaginationRight": "mover paginación a la derecha",
    "resetTime": "restablecer hora",
    "closeToast": "cerrar notificación",
    "selectedOption": "Opción seleccionada",
    "noSelectedOption": "Ninguna opción seleccionada",
    "breadcrumbs": "migas de pan",
    "counterValue": "valor del contador",
    "selectedDate": "fecha seleccionada",
    "selectedTime": "hora seleccionada",
    "progressState": "estado de progreso",
    "color": "color",
    "next": "Siguiente",
    "back": "Atrás",
    "finish": "Finalizar",
    "step": "paso",
    "progress": "progreso",
    "loading": "Cargando",
    "sliderValue": "El valor actual del deslizador es {value}",
    "switch": "Interruptor",
    "inputField": "Campo de entrada",
    "fileTypeIncorrect": "Tipo de archivo incorrecto",
    "select": "Seleccionar una opción"
  },
  "orgChart": {
    "title": "Organigrama",
    "menuTitle": "Organigrama",
    "menuName": "Organigrama",
    "organization": "Organización",
    "directReports": "Reportes Directos",
    "showEmployeeDetails": "Ver detalles del empleado",
    "goUp": "Subir un nivel",
    "navigateHere": "Navegar aquí",
    "vacant": "Vacante",
    "position": "Cargo",
    "plant": "Planta",
    "businessArea": "Área de Negocio",
    "personnelArea": "Área de Personal",
    "costCenter": "Centro de Costo",
    "hireDate": "Fecha de Contratación",
    "score360": "Puntaje 360",
    "scoreGoals": "Puntaje Metas",
    "score9box": "9-Box",
    "person": "Persona",
    "employeeType": "Tipo de Empleado",
    "view": "Vista",
    "viewOptions": {
      "basic": "Básico",
      "performance": "Performance",
      "headcount": "Headcount"
    },
    "headcount": {
      "directTotal": "Total Directo",
      "directSESNE": "Directo SE/SNE",
      "total": "Total Headcount",
      "spanOfControl": "Amplitud de Control",
      "se": "Empleados Asalariados",
      "sne": "Empleados SNE",
      "hourly": "Empleados por Hora",
      "truck": "Choferes",
      "work": "Trabajo"
    },
    "hidePeers": "Ocultar pares",
    "showPeers": "Mostrar par(es)",
    "collapse": "Contraer",
    "expand": "Expandir",
    "errors": {
      "salariedTypeCannotBeRemoved": "Los tipos de salario no pueden ser eliminados.",
      "employeeNotInTree": "Este empleado está fuera del árbol del organigrama y no se puede mostrar."
    }
  }
}
